export var getMobileLineHeightClassName = function (lineHeight) {
    return "mlh-" + lineHeight;
};
//# sourceMappingURL=get-mobile-line-height-class-name.js.map